import * as z from 'zod'

export const documentListFilterParamsSchema = z.object({
  page: z.number().int().positive().optional(),
  size: z.number().int().positive().optional(),
  sortBy: z.string().optional(),
  sortDesc: z.boolean().optional(),
  alerts: z.string().optional(),
  onlyMyCompanies: z.boolean().optional(),
  internal: z.boolean().nullable().optional(),
  bankAccountId: z.number().int().positive().nullable().optional(),
  companyId: z.union([z.number().int().positive(), z.string()]).nullable().optional(),
  contactId: z.number().int().positive().nullable().optional(),
  frequency: z.string().optional(),
  licenseId: z.number().int().positive().nullable().optional(),
  search: z.string().optional(),
  subjectType: z.string().optional()
})

export type DocumentListFilterParams = z.infer<typeof documentListFilterParamsSchema>
